/**
 * Media Service
 */

import { httpClient } from '../http-client';

const API_BASE_URL = '/api/v1';

export const MediaService = {
  /**
   */
  async uploadCoverImage(
    treeId: string,
    base64Image: string,
    attribution?: {
      coverAuthor?: string;
      coverAuthorUrl?: string;
      coverSource?: string;
      coverSourceUrl?: string;
    },
    providerInfo?: {
      imageProvider?: string;
      imageId?: string;
    }
  ): Promise<{
    imageUrl: string;
    coverAuthor?: string;
    coverAuthorUrl?: string;
    coverSource?: string;
    coverSourceUrl?: string;
  }> {
    try {
      const url = `${API_BASE_URL}/learning-trees/${treeId}/cover-image`;
      const response = await httpClient.put<{
        imageUrl: string;
        coverAuthor?: string;
        coverAuthorUrl?: string;
        coverSource?: string;
        coverSourceUrl?: string;
      }>(url, {
        image: base64Image,
        ...attribution,
        ...providerInfo,
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading cover image:', error);
      throw error;
    }
  },

  /**
   */
  async uploadProfileImage(
    base64Image: string
  ): Promise<{ imageUrl: string }> {
    try {
      const url = `${API_BASE_URL}/auth/me/profile-image`;
      const response = await httpClient.put<{ imageUrl: string }>(url, { base64Image });
      return response.data;
    } catch (error) {
      console.error('Error uploading profile image:', error);
      throw error;
    }
  },
};
